// extracted by mini-css-extract-plugin
export var alignCenter = "_8x-d";
export var bannerShown = "_8x-6";
export var buttonContent = "_8x-0";
export var cardList = "_8x-1";
export var centerContent = "_8x-2";
export var chevron = "_8x-3";
export var closePanelButton = "_8x-k";
export var conversationContextContainer = "_8x-l";
export var conversationDetailContainer = "_8x-4";
export var detailWrapper = "_8x-7";
export var dropdownButton = "_8x-e";
export var dropdownTitle = "_8x-9";
export var fullHeight = "_8x-5";
export var hidden = "_8x-a";
export var icon = "_8x-b";
export var mergeSuggestionWrapper = "_8x-m";
export var panel = "_8x-i";
export var portalButtonsWrapper = "_8x-c";
export var right = "_8x-j";
export var tableSummaryContainer = "_8x-8";
export var tableSummaryHeader = "_8x-g";
export var threeDotsButton = "_8x-f";
export var wide = "_8x-h";